// extracted by mini-css-extract-plugin
export default {"mCard":"PD-z","image":"QD-z","imageNoBackground":"RD-z","imageHasCategory":"SD-z","fullWidth":"TD-z"};